import {QueryKeys} from '../../../queryDefaults/QueryKeys.ts';
import {useHighFrequencyRefreshQuery} from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery.tsx';
import {PatientsApi} from '../../../apis/PatientsApi/PatientsApi.ts';

export function useGetPatientInvitationToken() {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.patientToken],
        queryFn: async () => {
            return await PatientsApi.getPatientInvitationToken();
        },
    });
}
